import {useRef, useState} from "react";
import {useDevice, useRelatedDevices} from "../api/client";
import {useParams} from "react-router-dom";
import DetailsTabs from "../components/DetailsPage/DetailsTabs";
import PhoneConfiguration from "../components/DetailsPage/PhoneConfiguration";
import PhoneHero from "../components/DetailsPage/PhoneHero";
import PhonePriceCard from "../components/DetailsPage/PhonePriceCard";
import PhoneRelatedGrid from "../components/DetailsPage/PhoneRelatedGrid";
import PhoneSpecifications from "../components/DetailsPage/PhoneSpecifications";
import {useCompareStore} from "../stores/useCompateStore";
import {number} from "framer-motion";

export default function PhoneInfoPage() {
    const {phoneId} = useParams();
    const { data: relatedPhones } = useRelatedDevices(phoneId);
    const {data} = useDevice(phoneId ?? "");
    const [storage, setStorage] = useState("256 GB");
    const [color, setColor] = useState("white");
    const [showAllCategories, setShowAllCategories] = useState(false);
    const ids = useCompareStore((state) => state.ids);
    const addToCompare = useCompareStore((state) => state.addToCompare);
    const removeFromCompare = useCompareStore((state) => state.removeFromCompare);
    const {isFull} = useCompareStore();
    const isComparing = ids.includes(number.parse(phoneId??"0"));

    const compareClick = (e: React.MouseEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (isComparing) {
            removeFromCompare(number.parse(phoneId??"0"));
        } else if (!isFull()) {
            addToCompare(number.parse(phoneId??"0"));
        }
    };

    const detailsRef = useRef<HTMLDivElement>(null);
    const specsRef = useRef<HTMLDivElement>(null);

    return (
        <main className="max-w-7xl mx-auto p-8 flex flex-col gap-10">
            <DetailsTabs detailsRef={detailsRef} specsRef={specsRef} />

            <PhoneHero
                device={data}
                detailsRef={detailsRef}
                centerFooter={
                    <PhoneConfiguration
                        device={data}
                        color={color}
                        storage={storage}
                        onColorChange={setColor}
                        onStorageChange={setStorage}
                    />
                }
                rightPanel={
                <div className="mt-4 flex flex-col w-full">
                    <PhonePriceCard />
                    <div className={`mt-2 pt-2 border-t border-slate-50 flex items-center gap-2 group ${
                        !isComparing && isFull() ? "opacity-50" : "cursor-pointer"
                    }`}>
                        <input
                            type="checkbox"
                            id={`compare-${phoneId}`}
                            disabled={!isComparing && isFull()}
                            checked={isComparing}
                            onChange={()=>{}}
                            onClick={compareClick} // Use onChange instead of onClick
                            className="cursor-pointer disabled:cursor-not-allowed"
                            title={!isComparing && isFull() ? "Comparison list is full!" : ""}
                        />
                        <label
                            htmlFor={`compare-${phoneId}`}
                            className={`select-none ${
                                !isComparing && isFull() ? "text-gray-400 cursor-not-allowed" : "text-slate-700 cursor-pointer"
                            }`}
                            title={!isComparing && isFull() ? "Comparison list is full!" : ""}
                        >
                            Compare
                        </label>
                    </div>
                </div>
                }
            />

            <div className="grid grid-cols-5 gap-16">
                <PhoneSpecifications
                    device={data}
                    showAllCategories={showAllCategories}
                    specsRef={specsRef}
                    onToggleShowAll={() => setShowAllCategories((prev) => !prev)}
                />
                <PhoneRelatedGrid devices={relatedPhones} />
            </div>
        </main>
    );
}